export const FETCH_OPERATIONS_PAST_DUE_PERIODS_REQUEST = 'FETCH_OPERATIONS_PAST_DUE_PERIODS_REQUEST';
export const FETCH_OPERATIONS_PAST_DUE_PERIODS_SUCCESS = 'FETCH_OPERATIONS_PAST_DUE_PERIODS_SUCCESS';
export const FETCH_OPERATIONS_PAST_DUE_PERIODS_FAILURE = 'FETCH_OPERATIONS_PAST_DUE_PERIODS_FAILURE';
